document.addEventListener('DOMContentLoaded', function () {
  var carousels = document.querySelectorAll('[data-cb-category-carousel]');

  if (!carousels.length) return;

  carousels.forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var slides = carousel.querySelectorAll('[data-carousel-slide]');

    if (!track || !prevBtn || !nextBtn || slides.length < 2) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    function getScrollAmount() {
      var firstSlide = slides[0];
      if (!firstSlide) return 0;

      var slideWidth = firstSlide.getBoundingClientRect().width;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);

      return slideWidth + gap;
    }

    function updateButtons() {
      var maxScrollLeft = track.scrollWidth - track.clientWidth;
      var currentScroll = Math.round(track.scrollLeft);

      prevBtn.classList.toggle('is-disabled', currentScroll <= 2);
      nextBtn.classList.toggle('is-disabled', currentScroll >= maxScrollLeft - 2);
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    updateButtons();
  });
});